import { render } from "./OdsWasteContainer.vue?vue&type=template&id=4da24ba8"
import script from "./OdsWasteContainer.vue?vue&type=script&lang=js"
export * from "./OdsWasteContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__